"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    container: {
        display: 'flex',
        marginRight: 20,
        marginLeft: 20
    },
    imageContainer: {
        flexShrink: 0,
        width: 75,
        marginRight: 20,
        paddingTop: 30
    },
    image: {
        height: 75,
        width: 75
    },
    userDetails: {
        width: '100%',
        marginTop: 20
    },
    publicKey: {
        fontFamily: '"Space Mono", monospace',
        whiteSpace: 'pre-wrap',
        fontSize: 10,
        padding: 14,
        backgroundColor: theme.grey8,
        borderRadius: 4
    }
});
//# sourceMappingURL=profile.style.js.map